export const NO_DATA_AVAILABLE_MESSAGE = 'No hotels for selected filters'
export const NO_RECENT_SEARCHES = 'No previous searches'
